import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchStoreReport, type StoreReport } from '@/lib/consignmentStoreReport';

export function useConsignmentStoreReport(companyId: string | null, clientId: string | null, asOf: string) {
  const [report, setReport] = useState<StoreReport | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const requestId = useRef(0);

  const load = useCallback(async () => {
    if (!companyId || !clientId || !asOf) return;
    const id = ++requestId.current;
    setLoading(true);
    setError(null);
    try {
      const r = await fetchStoreReport(companyId, clientId, asOf);
      if (id === requestId.current) setReport(r);
    } catch (e) {
      if (id !== requestId.current) return;
      setReport(null);
      setError(e instanceof Error ? e.message : 'שגיאה בטעינת הדוח');
    } finally {
      if (id === requestId.current) setLoading(false);
    }
  }, [companyId, clientId, asOf]);

  useEffect(() => { load(); }, [load]);

  return { report, loading, error, reload: load };
}
